import TemplateView from '../../TemplateView'
import {connect} from '../../redux/utils'
import {isSupportFormShown, showSupportQuestionButton} from './selectors'
import {openSupportForm} from './actions'
import {bindActionCreators} from 'redux'
import {calculateObjectCoords} from '../../atBrowserUtils'
import {supportPopupPositionStrategy} from './constants'
import SimpleTooltip from '../../SimpleTooltip'
import $ from '../../alias/jquery'
import messageResource from '../../messageResource'

class SupportQuestionButton extends TemplateView {
    constructor({
        openSupportForm = () => {},
    }) {
        super()

        this.state = {
            shown: false,
            active: false,
        }

        this.actions = {
            openSupportForm,
        }

        this.onStatePropertyChanged('active', (active) => {
            this.getEl().toggleClass('active', active)
        })

        this.onStatePropertyChanged('shown', (shown) => {
            this.getEl().toggle(shown)
        })
    }

    templateHtml() {
        return '<div class="supportQuestionButton"/>'
    }

    afterRender() {
        this.getEl().click(() => {
            if (this.state.shown) {
                const position = calculateObjectCoords(this.getEl()[0])
                this.actions.openSupportForm({
                    positionStrategy: supportPopupPositionStrategy.FROM_BOTTOM_RIGHT,
                    position,
                })
            }
        })
        this.tooltip = new SimpleTooltip({
            text: messageResource.getMessage('contact_support.got_a_question'),
            extraClass: 'supportQuestionButtonTooltip',
        }).init($('body'))
        this.tooltip.subscribeToMouseEvents(this.getEl())
    }
}

export default connect(
    state => ({
        shown: showSupportQuestionButton(state),
        active: isSupportFormShown(state),
    }),
    (dispatch) => ({
        openSupportForm: bindActionCreators(openSupportForm, dispatch),
    })
)(SupportQuestionButton)



// WEBPACK FOOTER //
// ./web/js/support/supportForm/SupportQuestionButton.js